import React, {Component} from 'react';
import {renderRoutes} from 'react-router-config';
import growthUtils from './growthUtil';
import {projectRoutes} from './Routes/GrowthExpRoutes';
import TrackingService from '../../services/TrackingService';

/* eslint-enable no-unused-vars */

type Props = {
	locale: string;
	env: string;
	history: Object;
	paidSubscriptionsInfo: Array<any>;
	currentTimestamp: string | null | undefined;
};

class Growth extends Component<Props> {
	componentWillUnmount() {
		growthUtils.config = undefined;
		growthUtils.workflow = '';
	}

	render() {
		const {locale, env, history, paidSubscriptionsInfo, currentTimestamp} = this.props;
		const imsData = growthUtils.getIMSData();

		if (growthUtils.isCctTodoWorkflow() && !window.growthTrackingService) {
			window.growthTrackingService = new TrackingService();
		}

		const passProps = {
			locale,
			env,
			location: window.location,
			history,
			imsData,
			paidSubscriptionsInfo,
			currentTimestamp,
		};

		return <div id='growth_section'>{renderRoutes(projectRoutes(), {...passProps})}</div>;
	}
}

export default {
	component: Growth,
};
